import React from 'react';
import CaregivingDashboard from './CaregivingDashboard';

function App() {
  return <CaregivingDashboard />;
}

export default App;